/**
 * Конфиг пунктов бокового меню (расширяемый список разделов приложения).
 * Добавление нового раздела: добавить объект с id, label, route, icon.
 */
export const sidebarMenuItems = [
  {
    id: 'calculate',
    label: 'Перейти в расчет',
    route: '/app/calculate',
    icon: 'fas fa-calculator',
    title: 'Перейти в расчет',
  },
  {
    id: 'history',
    label: 'Расчеты из истории',
    route: '/app/history',
    icon: 'fas fa-history',
    title: 'Расчеты из истории',
  },
  {
    id: 'report',
    label: 'Создать отчет',
    route: '/app/report',
    icon: 'fas fa-file-alt',
    title: 'Создать отчет',
  },
  {
    id: 'admin',
    label: 'Администрирование',
    route: '/app/admin',
    icon: 'fas fa-user-shield',
    title: 'Администрирование',
    adminOnly: true,
  },
];
